import { getRoot } from 'mobx-easy';
import { RootStore } from '@bringg-frontend/global-stores';

const loadData = async ({ taskId, withDriver = false }: { taskId: number; withDriver?: boolean }) => {
	try {
		const task = await getRoot<RootStore>().data.tasksStore.load(taskId);
		const taskDriver =
			withDriver && task?.user_id ? await getRoot<RootStore>().data.driversStore.load(task?.user_id) : undefined;

		return {
			taskId,
			taskTitle: task?.external_id || task?.title || task?.id.toString() || '',
			driver: taskDriver?.name
		};
	} catch (error) {
		console.error('Failed to load meetup task data', { error, taskId });
		return null;
	}
};

export const meetupProvider = { loadData };
